<app-title-bar rootBreadCrumbs="['i18n.core.navigation.admin']"
  titleText="i18n.domain.tag-master.title"></app-title-bar>
<div class="row">
  <div class="col-12 mb-2">
    <div class="d-flex">
      <app-client-autocomplete [(selectedClient)]="selectedClient"
        class="client-autocomplete me-2"></app-client-autocomplete>
    </div>
  </div>
</div>
@if(selectedClient){
<div class="control-section">
  <ejs-grid #grid class="grid-with-footer" width="100%" rowHeight="38" [dataSource]="data" [allowSorting]="true"
    [filterSettings]="filterSettings" [allowFiltering]="true" [allowPaging]="true" [pageSettings]="pageSettings"
    [searchSettings]="searchOptions" (actionComplete)="actionComplete($event)"
    [editSettings]="editSettings"
    (actionBegin)="actionBegin($event)"
    (rowDataBound)="rowDataBound($event)"
    >
    <ng-template #toolbarTemplate
                 let-data>
      <ejs-toolbar>
        <e-items>
          <e-item [text]="'i18n.domain.tag-master.delete-button-text' | translate"
                  prefixIcon="e-btn-icon icon-trash-can e-icons e-danger"
                  [disabled]="!grid.getSelectedRowIndexes().length"
                  (click)="onMultipleDelete()"></e-item>
        </e-items>
      </ejs-toolbar>
    </ng-template>
    <e-columns>
      <e-column field="id" [visible]="false" headerText="id" [isPrimaryKey]="true"></e-column>
      <e-column type='checkbox' width='50'></e-column>
      <e-column field="tagId" type="string" headerText="{{'i18n.domain.tag-master.grid.tagId' | translate}}"
        clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="description" type="string" headerText="{{'i18n.domain.tag-master.grid.description' | translate}}"
        clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="assignedOn" headerText="{{'i18n.domain.tag-master.grid.assignedOn' | translate}}"
              type="date"
              [filter]="dateFilter"
        clipMode="EllipsisWithTooltip">
        <ng-template #template let-data>
          {{data.assignedOn | date:'dd.MM.yyyy HH:mm:ss'}}
        </ng-template>
      </e-column>
      <e-column field="parkerName" type="string" headerText="{{'i18n.domain.tag-master.grid.parkerName' | translate}}"
        clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="isActive" headerText="{{'i18n.shared.fields.active' | translate}}" width="160px"
        [defaultValue]="true" [filter]="isActiveFilter">
        <ng-template #filterItemTemplate let-data>{{formatIsActive(data, 'isActive')}}</ng-template>
        <ng-template #template let-data>
          <span class="e-icons" [class.icon-checkmark]="data.isActive"></span>
        </ng-template>
      </e-column>
      <e-column headerText="" [commands]="gridCommands" width="120px"></e-column>
    </e-columns>
  </ejs-grid>
</div>
}
